import { createContext } from 'react';

const defaultContextValue = {
  isNavigatingToMovexBuilder: false,
  startMovexBuilderTransition: () => {},
  completeMovexBuilderTransition: () => {},
};

export const MovexBuilderRouteTransitionContext = createContext(defaultContextValue);
